import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Bell, AlertCircle } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { getNotices } from "../lib/api";

export default function Notices() {
  const [list, setList] = useState([]);

  useEffect(() => {
    getNotices().then(setList).catch(() => {});
  }, []);

  return (
    <div data-testid="notices-page">
      <PageHeader
        eyebrow="Updates & Announcements"
        title="Notice Board"
        subtitle="Stay updated with the latest news, announcements, and important dates from our college."
      />

      <section className="py-16 lg:py-24 bg-brand-ivory">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4" data-testid="notices-list">
          {list.map((n, i) => (
            <motion.div
              key={n.id}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className={`bg-white rounded-3xl p-5 lg:p-7 border ${
                n.is_urgent ? "border-brand-tertiary/40" : "border-brand-primary/10"
              } shadow-[0_6px_20px_rgba(15,76,58,0.05)] flex gap-4`}
              data-testid={`notice-${i}`}
            >
              <div className={`w-11 h-11 rounded-full flex-shrink-0 flex items-center justify-center ${
                n.is_urgent ? "bg-brand-tertiary text-white" : "bg-brand-accent text-brand-primary"
              }`}>
                {n.is_urgent ? <AlertCircle className="w-5 h-5" /> : <Bell className="w-5 h-5" />}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="font-serif text-xl text-brand-primary">
                    {n.title}
                  </h3>
                  {n.is_urgent && (
                    <span className="inline-block px-2 py-0.5 text-[10px] uppercase tracking-wider bg-brand-tertiary text-white rounded-full">
                      Urgent
                    </span>
                  )}
                </div>
                <p className="text-brand-ink/75 leading-relaxed mb-2">{n.content}</p>
                <div className="text-xs text-brand-muted tracking-wide">
                  {new Date(n.created_at).toLocaleDateString("en-IN", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </div>
              </div>
            </motion.div>
          ))}
          {list.length === 0 && (
            <div className="text-center py-20 text-brand-muted">
              No notices at the moment. Please check back later.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
